// PublicLayout.js
import { Box } from '@mui/material'
import NavBar from '../components/NavBar'

const PublicLayout = ({ children, toggleTheme, themeMode }) => {
  return (
    <Box>
      <NavBar
        showSidebarToggle={false}
        toggleTheme={toggleTheme}
        themeMode={themeMode}
      />
      <Box component="main" sx={{ mt: '64px', p: 3 }}>
        {children}
      </Box>
    </Box>
  )
}

export default PublicLayout
